import "../Styles/AboutPageStyles.css";
import { useLocation } from "react-router-dom";
import { lazy, Suspense, useEffect } from "react";
import SpinnerLoader from './../../../../assets/loader/SpinnerLoader';

const AboutPageProfileView = lazy(() => import("./../../../components/AboutPage/AboutPageProfile/View/AboutPageProfileView"));
const AboutCardView = lazy(() => import("./../../../components/AboutPage/AboutCards/View/AboutCardView"));
const LifeAtIinvsysView = lazy(() => import("./../../../components/AboutPage/LifeAtIinvsys/View/LifeAtIinvsysView"));
const LocationView = lazy(() => import("./../../../components/AboutPage/Locations/View/LocationsView"));
const CarrersandOurValuesView = lazy(() => import('./../../../components/CarrersPage/CareersandOurValues/View/CarresandOurValuesView'));

const AboutPageView = () => {
    const location = useLocation();

    useEffect(() => {
        if (location.hash === '#location') {
            const target = document.getElementById('location');
            if (target) {
                target.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [location]);



    return (
        <div className="about-page-main-view-container">
           
            <Suspense fallback={<SpinnerLoader/>}>
                <AboutPageProfileView />
            </Suspense>

            <Suspense fallback={null}>
                <AboutCardView />
            </Suspense>

            <Suspense fallback={null}>
                <CarrersandOurValuesView />
            </Suspense>

            <Suspense fallback={null}>
                <LifeAtIinvsysView />
            </Suspense>
            <Suspense fallback={null}>
                <LocationView />
            </Suspense>

        </div>
    )
}

export default AboutPageView;